export const handleErrorMessage = (error, sifra) => {
  if (error.message.indexOf('404') > -1) {
    return 'Neuspešan zahtev, pokušajte ponovo';
  }
  if (error.message.indexOf('500') > -1) {
    if (error.response?.data.includes('Cannot insert duplicate key')) {
      return 'Greška prilikom unosa podataka, zapis već postoji.';
    }
    if (
      error.response?.data.includes(
        'String or binary data would be truncated in table MokaDEV.dbo._Osobe, column JMBG',
      )
    ) {
      return 'Polje JMBG ima previše karaktera.';
    }
    if (
      error.response?.data.includes(
        'String or binary data would be truncated in table',
      )
    ) {
      return `Polje ${sifra || 'sifra'}  ima previše karaktera.`;
    }
    if (
      error.response?.data.includes(
        'The DELETE statement conflicted with the REFERENCE constraint',
      )
    ) {
      return 'Nije moguće obrisati zapis koji ima referencu ka veznoj tabeli.';
    }

    if (
      error.response?.data.includes(
        'Verzija za tip odabranog artikla već postoji',
      )
    ) {
      return 'Verzija za tip odabranog artikla već postoji!';
    }
    if (error.response?.data.includes('Dokument ne može da se obriše')) {
      return 'Dokument ne može da se obriše. Moraju se prvo obrisati stavke dokumenta';
    }
    return 'Greška prilikom unosa podataka.';
  }
  if (error.message.indexOf('400') > -1) {
    if (
      error.response?.data?.title.includes(
        'One or more validation errors occurred',
      )
    ) {
      return 'Neispravan tip podatka.';
    }
    return 'Greška prilikom unosa podataka.';
  }
  if (error.message === 'Network Error') {
    return 'Greška na mreži, pokušajte ponovo.';
  }
  return error?.message || 'Došlo je do greške.';
};
